// extracted by mini-css-extract-plugin
export default {"TAndCSection":"TAndCSection-module__TAndCSection--ZQOPJ","body":"TAndCSection-module__body--85-Rt"};